import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {withRouter, RouteComponentProps} from "react-router-dom"

import Loading from "@irati/ui/src/Loading"
import AuthStreamBase, {PBAUTHNotInitialised} from "@irati/auth/streams/auth/base"
import {hangPromise} from "@irati/utils/promise"
import AuthedChecker from "@irati/utils/history/routing/AuthedChecker"
import history from "@irati/utils/history"

/* This component is mounted in lots of places so just create once by using singleton variable */
let listener: ZenObservable.Subscription | null = null

interface Props extends RouteComponentProps {
  authed: AuthStreamBase<any>
  unauthed: AuthStreamBase<any>
}

class AuthProvider extends PureComponent<Props> {
  static childContextTypes = {
    authed: PropTypes.object.isRequired,
    unauthed: PropTypes.object.isRequired
  }

  getChildContext() {
    return {
      authed: this.props.authed,
      unauthed: this.props.unauthed
    }
  }

  state = {
    authInit: hangPromise()
  }

  componentDidMount() {
    const {authed, unauthed} = this.props
    this.setState({
      authInit: Promise.allSettled([authed.init(), unauthed.init()]).catch(() => {})
    })

    if (!listener) {
      this.listenForAuthClose()
    }
  }

  listenForAuthClose = () => {
    const handler = () => {
      if (this.props.authed.shouldRedirectOnLogout) {
        const {location} = this.props
        const {pathname, search} = location
        const nextPathname = `${pathname}${search}`
        history.replace({
          pathname: "/welcome/login",
          state: {...location.state, nextPathname}
        })
      }

      // re-register as 'complete' kills the previous subscription
      listener = this.props.authed.subscribe(() => {}, undefined, handler)
    }

    listener = this.props.authed.subscribe(() => {}, undefined, handler)
  }

  componentDidCatch(e: any) {
    if (e.code !== PBAUTHNotInitialised) {
      throw e
    }
  }

  render() {
    return (
      <Loading load={this.state.authInit}>
        <AuthedChecker>{this.props.children}</AuthedChecker>
      </Loading>
    )
  }
}

export default withRouter(AuthProvider)
